import { createContext } from 'react'

export type CustomComponentContextType = {
  processDefinitionKey: string
  fieldSpec: any
  taskData: any
  setValue: any
  control: any
  watch: any
}

export const CustomComponentContext = createContext<CustomComponentContextType>({
  processDefinitionKey: '',
  fieldSpec: null,
  taskData: null,
  setValue: null,
  control: null,
  watch: null,
})
